import {Input, InputWrapperDiv} from "../../../../../../../../components/ui/Input";
import React, {useState} from "react";
import Select from "react-select";
import select_styles from "../../../../../../../../layouts/elements";
import {Button} from "../../../../../../../../components/ui/Button";
import { useTranslation } from "react-i18next";

const INITIAL_DICT = {first_name: "", last_name: "", value: null, comment: ""}

const invalidData = (newData, opt) => {
    if (opt === "1" && !newData.value) return true
    if (opt === "2" && (newData.first_name === "" || newData.last_name === "")) return true
}

export default function DirectSolistPopupForm({dataList, cancelBtn, saveBtn, handlePopup}) {
    const { t } = useTranslation();
    const [directSelFormOpt, setDirectSelFormOpt] = useState("1")
    const [directNew, setDirectNew ] = useState(INITIAL_DICT)

    const OPTIONS = [
        { value: "1", label: t("popups.tech_info_add_people.search_in_list") },
        { value: "2", label: t("popups.tech_info_add_people.create_new") },
    ];

    const changeHandler = (value, opt, fieldName) => {
        if (opt === 'radio-button') {
            setDirectSelFormOpt(value)
            setDirectNew(INITIAL_DICT)
        } else if (opt === "formOpt") {
            setDirectNew({
                value: value.value,
                first_name: value.first_name,
                last_name: value.last_name,
                label: value.first_name+" "+value.last_name,
                comment: value.comment
            })
        } else {
            const newEntry = structuredClone(directNew)
            setDirectNew({...newEntry, [fieldName]: value, value: null})
        }
    }

    const handleClickFactory = (e) => {
        const buttonName = e.target.name

        if (buttonName === 'save') {
            if (invalidData(directNew, directSelFormOpt)) return
            // const newValue = {first_name: directNew.first_name, last_name: directNew.last_name, comment: "", pk: 0}

            return handlePopup({
                type: "save",
                newValue: directNew,
                // formOptions: directSelFormOpt
            })
        }
        if (buttonName === 'cancel') {
            return handlePopup({type: "cancel"})
        }
    };
    // console.log("in popup form", directNew, " lista:", dataList)
    return (<>
        <div className="row mb-3">
            <Input
                name="direction_manager"
                type={"radio"}
                options={OPTIONS}
                value={directSelFormOpt}
                style={{minWidth: "250px", width: "50%", marginLeft: "10px"}}
                onChange={val => changeHandler(val, "radio-button")}
                classNameDiv='col-sm-6'
                required
            />
        </div>
        {directSelFormOpt === "1" 
            ? <div>
                <Select
                    options={dataList}
                    value={directNew}
                    onChange={val => changeHandler(val, "formOpt")}
                    styles={select_styles}
                    isSearchable={true}
                    unstyled
                />
            </div>
            : (<>
                <div className='row pb-2'>
                    <InputWrapperDiv>
                        <Input
                            placeholder='First name *'
                            name='first_name'
                            value={directNew.first_name}
                            onChange={val => changeHandler(val, "first_name", "first_name")}
                            readOnly={true}
                            required={true}
                        />
                    </InputWrapperDiv>
                </div>
                <div className='row pb-2'>
                    <InputWrapperDiv>
                        <Input
                            placeholder='Last name *'
                            name='last_name'
                            value={directNew.last_name}
                            onChange={val => changeHandler(val, "last_name", "last_name")}
                            required={true}
                        />
                    </InputWrapperDiv>
                </div>
            </>)
        }
        <Button name="save" onClick={(e) => handleClickFactory(e)}
                variant="round" bWidth="small" styling="plain" className='mx-3' proposueButton="green">{saveBtn}
        </Button>
        <Button name="cancel" onClick={(e) => handleClickFactory(e)}
                variant="round" bWidth="small" styling="bordered" className='mx-3'>{cancelBtn}
        </Button>
    </>)
}